import { LocationType } from "./Enums";
import { Load } from "./Load";

export class DispatchItem {
    scheduleId: number = 0;
    dispatchId: number = 0;
    scheduleIdDisplay: string = '';
    dispatchIdDisplay: string = '';
    locCode: string = '';
    commodityCode: string = '';
    customerCode: string = '';
    customerName: string = '';
    truckerId: number = 0;
    truckerCode: string = '';
    truckerName: string = '';
    truckerCity: string = '';
    locationCode: string = '';
    locationName: string = '';
    locationCity: string = '';
    locationType: LocationType;
    locationState: string = '';
    originName: string = '';
    originCity: string = '';
    originState: string = '';
    destinationName: string = '';
    destinationCity: string = '';
    destinationState: string = '';
    destinationCustomerName: string = '';
    loadNumber: string = '';
    unloadNumber: string = '';
    loadNotes: string = '';
    locationNotes: string = '';
    internalNotes: string = '';
    numberOfLoads: number = 0;
    loads: string = '';
    rate: string = '';
    status: string = '';
    emailStatus: string = '';
    rogerStatus: string = '';
    enteredBy: string = '';
    loadBreakout: boolean = false;
    roundId: number = 0;
    round: string = '';
    selected: boolean = false;
    showMoreIcons: boolean = false;
    hasTexts: boolean = false;
    emailInProcess: boolean = false;
    rogerInProcess: boolean = false;
    compuweighEligible: boolean = false;
    loadList: Load[] = [];
    hasTextMessage: boolean = false;
    equipmentType: string = '';
    equipmentWeight: string = '';
    equipmentWeightUOM: string = '';
}
